import React from "react";

const ChevronLeftBlackBg = (props) => (
	<svg
		width="24"
		height="24"
		viewBox="0 0 24 24"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<rect width="24" height="24" rx="12" fill="black" fill-opacity="0.7" />
		<path
			d="M14.4299 8.2094C14.1141 7.9302 13.6038 7.9302 13.2879 8.2094L9.5704 11.4953C9.25453 11.7745 9.25453 12.2255 9.5704 12.5047L13.2879 15.7906C13.6038 16.0698 14.1141 16.0698 14.4299 15.7906C14.7458 15.5114 14.7458 15.0604 14.4299 14.7812L11.2874 11.9964L14.4299 9.21879C14.7458 8.9396 14.7377 8.48143 14.4299 8.2094Z"
			fill="white"
		/>
	</svg>
);

export default ChevronLeftBlackBg;
